import { Button } from '@material-ui/core';
import React from 'react';
import useStyles from './styles';


const IgnoreButton = ({handleClick}) => {
  const classes = useStyles();
  return (
    <Button
      variant="outlined"
      className={`m-1 uppercase w-80 ${classes.ignoreButton}`}
      onClick={handleClick}
    >
      Ignore
    </Button>
  );
};

export default IgnoreButton;
